import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[680px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20manga%20comic%20illustration%20style%20background%2C%20warm%20coral%20and%20golden%20gradient%20atmosphere%2C%20abstract%20ink%20wash%20textures%20with%20subtle%20comic%20panel%20lines%2C%20modern%20minimalist%20Japanese%20and%20Korean%20webtoon%20inspired%20aesthetic%2C%20soft%20dreamy%20lighting%2C%20no%20characters%2C%20clean%20artistic%20composition%2C%20warm%20inviting%20mood&width=1600&height=900&seq=hero-bg-manwa&orientation=landscape"
        alt="漫蛙漫画 - 免费漫画在线阅读平台"
        title="漫蛙漫画网 - 免费韩漫日漫国漫大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight max-w-3xl">
          漫蛙漫画 — 免费漫画的
          <span className="text-accent-400">无限世界</span>
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-lg text-white/80 max-w-2xl leading-relaxed">
          海量韩漫、日漫、国漫资源，高清漫画全集在线阅读。<br className="hidden md:block" />
          更新快、画质清、全免费，找好看的漫画就来漫蛙漫画网。
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/kr"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            开始阅读
            <i className="ri-arrow-right-line ml-2" />
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-3 gap-8 md:gap-16">
          {[
            { value: '10,000+', label: '漫画资源' },
            { value: '500万+', label: '月活用户' },
            { value: '99.9%', label: '高清画质' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">{stat.value}</p>
              <p className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 rounded-full bg-white/60 animate-bounce" />
        </div>
      </div>
    </section>
  );
}